import React, { useCallback, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Add, Extension } from "@mui/icons-material";

// core components
import Button from "components/CustomButtons/Button.js";

// Componets
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import { ModalV2 } from "components/Modal/ModalV2";
import NewGiotank from "./NewGiotank";

// config
import { getColumns } from "./config";

// Actions creators
import { getGiotanks, handleGiotanksInputs, clearError } from "redux/ducks/giotanks";
import { useSearch } from "hooks/useSearch";

const tableKey = "giotanks";

export default function Giotanks() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // selectors
  const { giotanks, isLoadingGiotanks, station } = useSelector((state) => state.giotanks);

  // Handlers
  const handleOpenGraph = useCallback((giotank) => {
    history.push(`/admin/grafica_giotank/${giotank?.id}/${giotank?.serialNumber}`);
  }, [history]);

  const handleOpenNew = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  // Se limpia el error del formulario para que no reaparezca al reabrir el modal
  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    dispatch(clearError());
  }, []);

  const handleSubmit = useCallback(() => {
    if (!station?.length) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }
    dispatch(getGiotanks(station));
  }, [station]);

  const columns = useMemo(
    () => getColumns(handleOpenGraph),
    [handleOpenGraph]
  );

  return (
    <>
      <CardTable
        hasHeader
        blockBtn
        icon={<Extension />}
        title="Giotanks"
        data={giotanks}
        columns={columns}
        isLoading={isLoadingGiotanks}
        rowText="dispositivos"
        tableKey={tableKey}
        tableContent={
          <TableInputs
            reducer="giotanks"
            stations
            multiStations
            stationsGridWidth={11}
            limitTags={-1}
            dispatchAction={handleGiotanksInputs}
            submitAction={handleSubmit}
            loading={isLoadingGiotanks}
          />
        }
        hasControl
        controls={
          <Button
            round
            justIcon
            color="info"
            onClick={handleOpenNew}
            tooltip="Agregar Giotank"
          >
            <Add style={{ margin: 0 }} />
          </Button>
        }
      />

      <ModalV2
        open={isModalOpen}
        onClose={handleCloseModal}
        toRight
      >
        <NewGiotank onClose={handleCloseModal} />
      </ModalV2>
    </>
  );
}
